// extracted by mini-css-extract-plugin
export default {"mobile":"WbWJGJcBkOHY0m0RI6f8"};